export const TokenConstants = {
    Session_Expired: "Your session has been expired, Please login again!"
}

export const ErrorMessageConstants = {
    Message: "Something went wrong ! Please try again after sometime."
}